<template>
	<bernstein-layout>
		<Head title="Return Article Statistics " />
		<div class="flex w-full flex-wrap justify-center">
			<!-- {{$page.props}}  -->
			<order-create class="w-auto" :downloadIcon="downloadIcon"> </order-create>
			<div
				class="gird w-full grid-flow-col grid-cols-1 place-content-center content-center px-2"
			>
				<p class="px-2 py-4 text-center text-xl font-bold text-gray-800">
					Download Order Items
				</p>

				<div
					v-if="isLink"
					class="mb-4 flex flex-col items-center bg-slate-50 py-6 px-2"
				>
					<p class="mb-6">
						It will take a while to create the download. Once, it is created, it
						will download automatically. You can also click here to download the
						report.
					</p>

					<a :href="$page.props.flash.message">
						<jet-button class="w-full bg-slate-400 text-center">
							<span class="m-auto py-2 text-center"> DOWNLOAD HERE</span>
						</jet-button>
					</a>
				</div>
				<div
					v-if="form.processing"
					class="mx-auto flex flex-wrap items-center justify-center space-x-3 text-center"
				>
					<p class="py-2 font-bold text-red-600">Download-Vorbereitung läuft</p>
					<div class="my-2 p-2">
						<!-- {{downloadIcon}}  -->
						<!-- <img :src="downloadIcon" />  -->
						<img
							:src="downloadIcon"
							alt="HTML5 Icon"
							width="250"
							height="250"
						/>
					</div>
				</div>
				<form
					@submit.prevent="submit"
					class="mx-auto flex w-full max-w-md flex-col content-center"
				>
					<div class="mb-2 py-2">
						<label for="start_date"> Startdatum </label>

						<jet-input
							id="start_date"
							type="date"
							class="mt-1 block w-full"
							v-model="form.start_date"
							required
							autofocus
						/>
					</div>
					<div class="mb-2 py-2">
						<label for="end_date"> Enddatum </label>
						<jet-input
							id="end_date"
							type="date"
							class="mt-1 block w-full"
							v-model="form.end_date"
							autofocus
						/>
					</div>
					<div class="mb-2 py-2">
						<!-- <button type="submit"> Addison Export </button> -->

						<jet-button
							class="w-full bg-slate-400 text-center"
							:class="{ 'opacity-25 ': form.processing }"
							:disabled="form.processing"
						>
							<span class="m-auto py-2 text-center"> Download Order Items</span>
						</jet-button>
					</div>
				</form>
			</div>
		</div>
	</bernstein-layout>
</template>
<script>
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetLabel from "@/Jetstream/Button.vue";

export default {
	props: {
		downloadIcon: String,
	},
	components: {
		BernsteinLayout,
		JetButton,
		JetInput,
		JetLabel,
	},
	data() {
		return {
			form: this.$inertia.form({
				_method: "PUT",
				start_date: null,
				end_date: null,
				processing: false,
			}),
			isLink: false,
		};
	},
	methods: {
		submit() {
			this.form.processing = true;
			this.form.post(
				route("orderitems.download"),
				{
					// errorBag: 'updateProfileInformation',
					preserveScroll: true,
					resetOnSuccess: false,
					onSuccess: (response) => this.downloadExport(response),
				},
				{}
			);
		},
		downloadExport(response) {
			//   alert("test");
			// console.log(response.props.flash.message);
			this.form.processing = false;
			this.isLink = true;
			var link = response.props.flash.message;
			var element = document.createElement("a");
			element.setAttribute("href", link);
			element.style.display = "none";
			document.body.appendChild(element);
			element.click();
			// document.body.removeChild(element);
		},
	},
};
</script>
